
import type { FC } from 'react';
import classNames from 'classnames';
import { useDrop } from 'react-dnd';
import { useDragAndDrop } from '@/utils/useDragAndDrop';
import { IDragQuestionProps } from '@/utils/ctype';
import GroupTitle from '@/pages/Mock/components/GroupTitle';
import HtmlParser from '../../../components/HtmlParser';
import KeyboardTip from '../../../components/KeyboardTip';
import Drop from '../../../components/Drop';
import Drag from '../../../components/Drag';

import style from './index.module.less';


const Container: FC<IDragQuestionProps> = function SentencePairingQuestions(props) {
  
  const { data , saveAnswerHandle, pageData, loadAnswered, answerMap, keyIndex, setShowDragFieldHandle, setFocusIndexHandle} = props;

  const { list }= data;

  const {
    dustbins,
    boxes,
    recoverOption,
    recoverBlank,
    handleDrop,
    handleDropOptionList
  } = useDragAndDrop(data, {optionHidden: 'hidden', type: 'sentencePairingOption', accepts: ['sentencePairingOption', 'sentencePairingBlank'], blankType: 'sentencePairingBlank', saveAnswerHandle, pageData, loadAnswered, answerMap});

  const [{ isOver, canDrop }, drop] = useDrop({
    accept: ['sentencePairingOption', 'sentencePairingBlank'],
    drop: handleDropOptionList,
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });
  return (
    <div className={style.box}>
      <KeyboardTip></KeyboardTip>
      <div className={style.question}>
        {dustbins.map(({ accepts, lastDroppedItem, data, type, uid }, index) => (
          <div data-exam-text-size="18" className={style.questionItem} key={index}>
            <div className={style.questionText} data-key={`question.question.${keyIndex}.list.${index}.title`}>
              <HtmlParser htmlString={list[index].title}></HtmlParser>
            </div>
            <Drop
              accept={accepts}
              lastDroppedItem={lastDroppedItem}
              onDrop={(item) => handleDrop(index, item)}
              index={index}
              key={index}
              data={data}
              recoverOption={recoverOption}
              recoverBlank={() => recoverBlank(index)}
              type={type}
              blankClass={style.blank}
              uid={uid}
              // optionClass={style.option}
              id={`question${data.number}`}
              onFocus={() => setFocusIndexHandle&&setFocusIndexHandle(data.number)}
            />
          </div>
          
        ))}
      </div>
      {
        data.title ? <GroupTitle title={data.title} /> : null
      }

      

      <div data-exam-drop-hover={isOver} className={classNames(style.answer, isOver ? style.isOver : '')} ref={drop}>
        {
          boxes.map(({ data, type, display, optionHidden, uid}, index) => {
            return (
              <Drag data={data} type={type} key={index} index={index} display={display} optionHidden={optionHidden}
                optionClass={style.mt15} uid={uid} setShowDragFieldHandle={setShowDragFieldHandle}/>
            );
          })
        }
        
      </div>
    </div>
  );
};

export default Container;
